import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ANIMATION_TYPES;
(function(ANIMATION_TYPES) {
    ANIMATION_TYPES["NONE"] = "";
    ANIMATION_TYPES["FADE_IN"] = "animate-fade-in";
    ANIMATION_TYPES["SLIDE_DOWN_FADE_IN"] = "animate-slide-down-fade-in";
    ANIMATION_TYPES["EASE_IN_BG"] = "animate-ease-in-bg";
    ANIMATION_TYPES["SLIDE_IN"] = "animate-slide-in";
    ANIMATION_TYPES["SLIDE_IN_FADE_IN"] = "animate-slide-in-fade-in";
})(ANIMATION_TYPES || (ANIMATION_TYPES = {}));
const AnimatedContainer = ({ as: Component = 'div', animationType = '', className, children, delay })=>jsx(Component, {
        className: classNames(className, {
            [animationType]: animationType
        }),
        style: animationType ? {
            '--animation-delay': delay
        } : undefined,
        children: children
    });

export { ANIMATION_TYPES, AnimatedContainer };
